import _ from 'lodash';

// Returns id => Promise of the location, or null when Instagram doesn't know it.
// Long timeout: a cold start of the lookup Lambda can take several seconds.
export const buildLocationLookup = buildRESTClient => {
  const client = buildRESTClient({
    baseURL: process.env.REACT_APP_PUBLIC_ACCESS_API,
    hasToken: false,
    timeout: 15000,
  });
  return id => client.get(`instagram/locations/${id}`)
    .then(response => _.get(response, 'data.data.location', null))
    .catch(error => {
      if (_.get(error, 'response.status') === 404) return null;
      throw error;
    });
};

// Returns text => Promise of matching places ({ id, name, address, city }).
export const buildLocationSearch = buildRESTClient => {
  const client = buildRESTClient({
    baseURL: process.env.REACT_APP_PUBLIC_ACCESS_API,
    hasToken: false,
    timeout: 15000,
  });
  return text => client.get('instagram/locations', { params: { q: text } })
    .then(response => _.get(response, 'data.data.locations', []));
};

export default buildLocationLookup;



/** WEBPACK FOOTER **
 ** ./src/utils/instagram-location-lookup.js
 **/